import { CART_MODULE, PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { InvoiceDataResponse, InvoiceDetails } from "@/api_framework/api_modals/payment";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentInvoiceReturnRefundDetailsAPI = () => {
  const configuration = useConfiguration();
  const [invoiceDetailsData, setInvoiceDetailsData] = useState<InvoiceDetails>(null);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletTableInProgress
  const execute = useCallback(
    async (creditNoteId: string, flag: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${CART_MODULE?.INVOICE_RETURN_REFUND?.baseURL}?invoice_id=${creditNoteId}&type=${flag}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<InvoiceDataResponse>) => {
            if (res.data.status === true) {
              setInvoiceDetailsData(res.data.data);

              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              setInvoiceDetailsData(null);

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            setInvoiceDetailsData(null);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setInvoiceDetailsData(null);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { invoiceDetailsData, execute };
};
